var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.pageData.currentPage,"page-size":_vm.pageData.pageSize,"layout":"total, prev, pager, next, jumper","total":_vm.pageData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }